import { useSelector } from "react-redux";
import LoadingPage from "../../components/LoadingComponent";
import { useTheme } from "@emotion/react";
import { Box, CircularProgress, Grid, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import i18n from "../../i18n/i18n";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DashboardFilterComponent from "../../components/Utilities/DashboardFilterComponent";
import TableComponent from "../../components/TableComponent/TableComponent";
import Header from "../../components/PageHeader/header";
import notify from "../../components/notify";
import formatDateToString from "../../components/Utilities/FormatDateToString";
import { useEffect } from "react";
import { GET_FILTERED_EXAMS } from "../../graphql/ExamsQueries";
import FilterComponent from "../../components/TableComponent/FilterComponent";
import ExportExcelAndPDF from "../../components/Utilities/ExportExcelAndPDF";
import { examTypes, isOpen, ticketTypes } from "../../constants";
import { GET_ALL_SUPPORT_TICKETS, GET_SUPPORT_TICKETS_BY_USER_ID } from "../../graphql/supportTicketQueries";
import usePermissionsByModule from "../../hooks/getPermissionsByScreen";
import NoPermissionPage from "../../components/NoPermissionPage";
import logger from "../../utils/logger";




export default function GetAllSupportTicketsPage() {

    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [searchParams, setSearchParams] = useSearchParams();

    const isArabic = i18n.language === "ar";
    const me = useSelector((state) => state.user.loggedUser);
const { view, create, update, delete: canDelete } = usePermissionsByModule("supportTickets");

    // get tickets for student and doctor
    const [
        GetSupportTicketsByUser,
        {
            data: { getSupportTicketsByUser } = {},
            loading: pageLoading,
        },
    ] = useLazyQuery(GET_SUPPORT_TICKETS_BY_USER_ID, {
        fetchPolicy: "network-only",
    });

    // get tickets for admin
    const [
        GetSupportTickets,
        {
            data: { getSupportTickets } = {},
            loading: pageAdminLoading,
        },
    ] = useLazyQuery(GET_ALL_SUPPORT_TICKETS, {
        fetchPolicy: "network-only",
    });


    useEffect(() => {
        logger.log("me", me);

        if (me?.id) {

            if (me?.role == "admin") {
                GetSupportTickets();
            }
            else {
                GetSupportTicketsByUser({
                    variables: {
                        userId: me.id,
                    },
                });
            }

        }

    }, [me]);

    let columns = [];

    if (me?.role == "admin") {
          columns = [
            { key: "serial", label: t("Serial") },
            { key: "subject", label: t("title") },
            { key: "type", label: t("profile.Gender") },
            {key:"user_name",label:t("Dashboard.userName")},
            { key: "status", label: t("Status") },
        ];
    }
    else {
        columns = [
            { key: "serial", label: t("Serial") },
            { key: "subject", label: t("title") },
            { key: "type", label: t("profile.Gender") },
            { key: "status", label: t("Status") },
        ];
    }

    let ticketsToShow;

    if (me?.role == "admin") {
        ticketsToShow = getSupportTickets?.map((ticket) => {
            return {
                ...ticket,
                subject: ticket?.subject,
                type: isArabic ? ticketTypes.find((type) => type.id === ticket?.type)?.labelAr : ticketTypes.find((type) => type.id === ticket?.type)?.labelEn,
                status: ticket?.status == "open" ? true : false,
                user_name:ticket?.user_id?.fullname
            }
        });
    }
    else {
        ticketsToShow = getSupportTicketsByUser?.map((ticket) => {
            return {
                ...ticket,
                subject: ticket?.subject,
                type: isArabic ? ticketTypes.find((type) => type.id === ticket?.type)?.labelAr : ticketTypes.find((type) => type.id === ticket?.type)?.labelEn,
                status: ticket?.status == "open" ? true : false
            }
        });

    }

    logger.log("ticketsToShow", ticketsToShow);

    const fetchAndExport = async (type) => {
        try {
            if (!ticketsToShow || ticketsToShow.length === 0) {
                notify(isArabic ? "لا توجد بيانات للطباعة" : "No data to export", "error");
                return;
            }

            const exportData = ticketsToShow.map((ticket, i) => {
                let row = {
                    ID: i + 1,
                    [t("title")]: ticket?.subject,
                    [t("profile.Gender")]: ticket?.type,
                };

                if (me?.role === "admin") {
                    row[t("Dashboard.userName")] = ticket?.user_name;
                }

                row[t("Status")] = ticket?.status ? t("open") : t("closed");
                return row;
            });

            ExportExcelAndPDF({
                exportData,
                isArabic,
                reportTitle: isArabic ? "تذاكر الدعم الفني" : "Support Tickets",
                type
            });
        } catch (err) {
            logger.error("Export error:", err);
        }
    };
    const addNavigate = () => navigate('add');

    const handleDetailsClick = (selectedRow) => {
      if(!update) return notify(t("no_permission.title"),"error");


        let row;

        if (me?.role == "admin") {
            row = getSupportTickets?.find(el => el?.id == selectedRow?.id);
        }
        else {
            row = getSupportTicketsByUser?.find(el => el?.id == selectedRow?.id);
        }

        logger.log("row", row);

        navigate(`details/${selectedRow?.id}`, {
            state: row
        });

    }

    logger.log("getSupportTicketsByUser", getSupportTicketsByUser);

    let translateText = isArabic ? "تذكرة" : "Ticket";
    if (!view) return <NoPermissionPage />;

    if (pageLoading || pageAdminLoading) return <LoadingPage />;
    return (
        <Box sx={{ p: 3, backgroundColor: "background.paper" }}>
            <Grid container spacing={3}>
                <Grid item
                    sm={12} md={12}
                    sx={{
                        overflowX: "auto", // ✅ مهم جدًا عشان الجدول يعمل scroll داخل الـ Grid
                    }}
                >

                    <Header
                        title={t("Dashboard.support")}
                        subtitle={t("Dashboard.support")}
                        i18n={i18n}
                        haveBtn={ me?.role == "admin" ? false :true}
                        btn={t("addItem", { item: translateText })}
                        btnIcon={<ControlPointIcon sx={{ [isArabic ? "mr" : "ml"]: 1 }} />}
                        onSubmit={addNavigate}
                        isExcel
                        isPdf
                        isPrinter
                        onExcel={() => fetchAndExport("excel")}
                        onPdf={() => fetchAndExport("pdf")}
                        onPrinter={() => fetchAndExport("print")}
                    />

                    <TableComponent
                        columns={columns}
                        data={ticketsToShow}
                        // onViewDetails={(r) => navigate(`/userDetails/${r.id}`)}
                        loading={pageLoading}
                        // isUsers={true}
                        // statusKey="status"
                        arPopulateKey={"title_ar"}
                        enPopulateKey={"title_en"}
                        sx={{
                            flex: 1,
                            overflow: "auto",
                            boxShadow: 1,
                            borderRadius: 1,
                            width: "100%",
                        }}
                        handleDetailsClick={handleDetailsClick}
                        // onStatusChange={onStatusChange}
                        showStatusChange={false}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}
